@if (!is_review) {
  <!-- Activity ID bar -->
  <div class="row mb-3" [ngClass]="{ 'mb-3': !is_tmo_environment, 'mb-2': is_tmo_environment }">
    @if (is_tmo_environment && is_summary_page) {
      <div class="col col-12 col-md-6 mb-2">
        <h4 class="display-4 mb-0 lh-1">
          <span class="d-inline-flex">
            {{ 'order_number' | translate }}: {{ carrier_order_number || '' }}
            <span
              ngbTooltip="{{ 'order_number_tooltip' | translate }}"
              placement="right"
              class="material-icons fs-5 ms-1 text-info cursor-pointer"
            >
              help
            </span>
          </span>
        </h4>
      </div>
    }

    <div
      [ngClass]="{
        'col col-12 col-md-6 text-md-end': is_tmo_environment,
        'col col-12 col-lg-5': !is_tmo_environment
      }"
    >
      <h4 class="display-4 m-0">
        {{ 'activity_id' | translate }}:
        <a [href]="source_order_details.source_order_url" target="_blank">
          {{ source_order_details.source_order_id }}
        </a>
      </h4>
    </div>

    @if (
      !(is_tmo_environment && is_summary_page) && price_summary?.is_bulk_order && related_order_url
    ) {
      <div class="col col-12 col-lg-5 ms-auto mt-2 mt-lg-0">
        <h4 class="display-4 m-0 d-flex gap-2 justify-content-start justify-content-lg-end">
          <span class="text-nowrap">{{ 'related_activity_ids' | translate }}:</span>
          <a [href]="related_order_url" target="_blank">{{ 'view_details' | translate }}</a>
        </h4>
      </div>
    }

    @if (
      !(is_tmo_environment && is_summary_page) &&
      !price_summary?.is_bulk_order &&
      (related_order_info ?? []).length > 0
    ) {
      <div class="col col-12 col-lg-5 ms-auto mt-2 mt-lg-0">
        <h4 class="display-4 m-0 d-flex gap-2 justify-content-start justify-content-lg-end">
          <span class="text-nowrap">{{ 'related_activity_ids' | translate }}:</span>
          <p class="m-0">
            @for (related_info of related_order_info ?? []; track related_info) {
              <ng-container>
                <a [href]="related_info.url" target="_blank">{{ related_info.id }}</a>
                @if (!$last) {
                  <span>, </span>
                }
              </ng-container>
            }
          </p>
        </h4>
      </div>
    }
  </div>
  <!-- Order placer/recipient card -->
  <div class="card shadow-sm mb-3">
    <div class="card-body">
      <div class="card-title mb-3">
        <h4>
          {{ source_order_details.source_order_type }}:
          <ng-container>
            @switch (order_type_id) {
              @case ([1, 1001].includes(order_type_id) && order_type_id) {
                <span>
                  {{ source_order_details.carrier.name }}
                </span>
              }
              @case ([3, 9].includes(order_type_id) && order_type_id) {
                <span>
                  {{ asset_details.existing_asset.device.manufacturer }}
                  {{ asset_details.existing_asset.device.model }}
                  @if (asset_details.existing_asset.device.imei) {
                    <span> ({{ asset_details.existing_asset.device.imei }}) </span>
                  }
                </span>
              }
              @case ([14].includes(order_type_id) && order_type_id) {
                <span>
                  @if (asset_details.existing_asset.device) {
                    <span>
                      {{ asset_details.existing_asset.device.manufacturer }}
                      {{ asset_details.existing_asset.device.model }}
                      {{ asset_details.existing_asset.device.size }} -
                      {{ asset_details.existing_asset.device.color }}
                    </span>
                  } @else {
                    @if (asset_details.existing_asset.line.device_catalog_name) {
                      <span>
                        {{ asset_details.existing_asset.line.device_catalog_name }}
                      </span>
                    } @else {
                      {{ asset_details.existing_asset.line.international_number }}
                    }
                  }
                </span>
              }
              @case ([17].includes(order_type_id) && order_type_id) {
                <span>
                  {{ deviceItem?.name }}
                </span>
              }
              @default {
                <span>
                  @if (asset_details.existing_asset && asset_details.existing_asset.line) {
                    <span>
                      {{ asset_details.existing_asset.line.international_number }}
                    </span>
                  }
                </span>
              }
            }
          </ng-container>
        </h4>
      </div>
      <div class="row g-3">
        <div class="col">
          <div class="d-flex flex-column">
            <span class="fw-normal mb-2">{{ 'order_placer' | translate }}:</span>
            <span class="d-flex">
              {{ source_order_details.order_initiator.first_name }}
              {{ source_order_details.order_initiator.last_name }} ({{
                source_order_details.order_initiator.email
              }})
              <ts-copy [text]="source_order_details.order_initiator.email" />
            </span>
          </div>
        </div>
        <div class="col">
          <div class="d-flex flex-column">
            <span class="fw-normal mb-2">{{ 'order_recipient' | translate }}:</span>
            <span class="d-flex">
              {{ source_order_details.account_holder.first_name }}
              {{ source_order_details.account_holder.last_name }}
              ({{ source_order_details.account_holder.email }})
              <ts-copy [text]="source_order_details.account_holder.email" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card shadow-sm order-confirmation">
    <div class="card-body">
      <!-- What next notification -->
      <div class="row mb-2">
        <div class="col">
          <h5
            class="order-confirmation__sub-title"
            [innerHTML]="
              'your_order_status'
                | translate: '<b>' + source_order_details.source_system_status + '</b>.'
                | domSanitizer
            "
          ></h5>
          @if (order_status_desc) {
            <span
              class="fw-light normalize-external-styles"
              [innerHTML]="order_status_desc | domSanitizer"
            ></span>
          }
        </div>
      </div>
      <!-- Progress tracker -->
      <div class="row py-5 m-auto order-confirmation__tracker">
        <ts-order-tracker [order_tracker_config]="order_tracker" />
      </div>
      <!-- Activity asset card -->
      <ts-selected-asset
        [order_type_id]="order_type_id"
        [asset_details]="asset_details"
        [additional_info]="additional_info"
        page_key="confirmation"
      />
      <!-- Order details -->
      @if (price_summary && ![19].includes(order_type_id)) {
        <div>
          <hr class="mx-n3" />
          <ng-template [ngTemplateOutlet]="orderDetailsHeader" />
          @if (price_summary && price_summary.is_bulk_order) {
            <ng-template [ngTemplateOutlet]="bulkOrderQuantityLabel" />
          }
          @if (price_summary && price_summary.is_bulk_order) {
            <div class="row">
              <ts-bulk-order-details class="d-block mb-3" [price_summary]="price_summary" />
            </div>
          } @else {
            <!-- One time cost table -->
            @if (price_summary && price_summary.one_time_costs) {
              <div class="table-responsive">
                <table class="table table-sm non-table">
                  <thead>
                    <th scope="col" class="h5 pb-2">
                      {{ 'one_time_costs' | translate }}
                      <span
                        >({{ (isEmployeePayable() ? 'employee' : 'company') | translate }})</span
                      >
                    </th>
                    <th scope="col"></th>
                  </thead>
                  <tbody class="table-group-divider border-light-subtle">
                    @for (item of price_summary.one_time_costs; track item; let last = $last) {
                      <tr>
                        <td class="w-100">
                          {{ item.name }} - {{ item.description }} (x
                          {{ item.quantity | number: '1.0-0' }}) &#64;
                          {{ item.cost_to_currency }}
                          @if (item?.additional_info?.option) {
                            <div>
                              ({{ 'option' | translate }}: {{ item?.additional_info?.option }})
                            </div>
                          }
                        </td>
                        <td class="text-end text-nowrap" [ngClass]="{ 'border-bottom-0': last }">
                          @if (
                            item.employee_cost_to_currency && (item.type == 'ACCESSORY' || 'DEVICE')
                          ) {
                            <span
                              class="material-icons-outlined pe-2 card-icon cursor-default"
                              placement="top"
                              ngbTooltip="{{ 'employee_cost' | translate }}"
                            >
                              credit_card
                            </span>
                          }
                          {{ item.total_cost_to_currency }}
                        </td>
                      </tr>
                    }
                  </tbody>
                  <tfoot class="table-group-divider border-light-subtle">
                    <td class="h5 pt-3">{{ 'total' | translate }}</td>
                    <td class="h5 pt-3 text-end text-nowrap">
                      {{ price_summary.total_one_time_cost }}
                    </td>
                  </tfoot>
                </table>
              </div>
            }
            <!-- Recurring cost table -->
            @if (price_summary && price_summary.recurring_costs) {
              <div class="table-responsive mt-3">
                <table class="table table-sm mb-0 non-table">
                  <thead>
                    <th scope="col" class="h5 pb-2">
                      {{ 'recurring_costs' | translate }}
                    </th>
                    <th scope="col"></th>
                  </thead>
                  <tbody class="table-group-divider border-light-subtle">
                    @for (item of price_summary!.recurring_costs; track item; let last = $last) {
                      <tr>
                        <td class="w-100">
                          {{ item.name }}
                          @if (item?.included) {
                            <span> ({{ 'included' | translate }}) </span>
                          }
                          @if (item?.additional_info?.unchanged) {
                            <span> ({{ 'unchanged' | translate }}) </span>
                          }
                        </td>
                        <td class="text-end text-nowrap" [ngClass]="{ 'border-bottom-0': last }">
                          @if (getFeatureType(item)) {
                            <span class="pe-1">
                              <span
                                class="d-inline-flex"
                                [class.themed-badge-success]="item.sub_type === 'ADDED_FEATURE'"
                                [class.themed-badge-danger]="item.sub_type === 'REMOVED_FEATURE'"
                              >
                                ({{ getFeatureType(item) }})
                              </span>
                            </span>
                          }
                          <span
                            [class.text-decoration-line-through]="
                              item.sub_type === 'REMOVED_FEATURE'
                            "
                          >
                            {{ item.total_cost_to_currency }}/mo.
                          </span>
                        </td>
                      </tr>
                    }
                  </tbody>
                  <tfoot class="table-group-divider border-light-subtle">
                    <td class="h5 pt-3">{{ 'total' | translate }}</td>
                    <td class="h5 pt-3 text-end text-nowrap">
                      {{ price_summary.total_recurring_cost }}/mo.
                    </td>
                  </tfoot>
                </table>
              </div>
            }
          }
        </div>
      }
      <!-- Address section -->
      @if (show_order_details) {
        <div>
          @if (has_price_summary) {
            <hr class="mx-n3" />
          }
          <ng-template [ngTemplateOutlet]="addressDetails" />
        </div>
      }
      @if (source_order_details.payment_details?.card_number) {
        <div>
          <hr class="mx-n3" />
          <h4 class="mb-3">{{ 'payment_details' | translate }}</h4>
          <div class="row mb-3">
            <div class="col col-12">
              <h6 class="mb-2">
                {{ 'your_total' | translate }}:
                {{
                  price_summary?.is_bulk_order
                    ? source_order_details.payment_details.bulk_cost_to_card
                    : source_order_details.payment_details.cost_to_card
                }}
              </h6>
              <span>
                {{ 'payment_method_disclosure' | translate }}
              </span>
            </div>
          </div>
          <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4">
            @if (source_order_details.payment_details) {
              <div class="col">
                <div class="d-flex flex-column">
                  <span class="fw-normal mb-2"> {{ 'payment_method' | translate }}: </span>
                  <span class="d-flex align-items-center">
                    @if (source_order_details.payment_details.card_type) {
                      <img
                        class="img-fluid pe-2 payment-card-img"
                        src="{{
                          getPaymentCardImage(source_order_details.payment_details.card_type)
                        }}"
                        alt="{{ 'payment_card' | translate }}"
                      />
                    }
                    {{ source_order_details.payment_details.card_number }}
                  </span>
                  <span>{{ source_order_details.payment_details.cardholder_name }}</span>
                  <span>{{ source_order_details.payment_details.expires }}</span>
                </div>
              </div>
            }
            @if (source_order_details.payment_details.billing_address) {
              <div class="col">
                <div class="d-flex flex-column">
                  <span class="fw-normal mb-2"> {{ 'billing_address' | translate }}: </span>
                  <span>{{ source_order_details.payment_details.billing_address.address1 }}</span>
                  <span>{{ source_order_details.payment_details.billing_address.address2 }}</span>
                  <span>
                    {{ source_order_details.payment_details.billing_address.city }},
                    {{ source_order_details.payment_details.billing_address.state }}
                    {{ source_order_details.payment_details.billing_address.zip }}
                  </span>
                  <span>{{ source_order_details.payment_details.billing_address.country }}</span>
                </div>
              </div>
            }
          </div>
        </div>
      }

      @if (source_order_details?.new_carrier_account || source_order_details?.old_carrier_account) {
        <div>
          <hr class="mx-n3" />
          <h4 class="mb-3">{{ 'carrier_account' | translate }}</h4>
          <div class="row flex-column flex-md-row g-3">
            <div class="col d-flex flex-column">
              <span class="fw-normal mb-2">{{ 'current_carrier_account' | translate }}</span>
              <span>
                {{ source_order_details?.old_carrier_account?.display_name ?? ('n_a' | translate) }}
              </span>
            </div>
            <div class="col d-flex flex-column">
              <span class="fw-normal mb-2">{{ 'new_carrier_account' | translate }}</span>
              <span>
                {{ source_order_details?.new_carrier_account?.display_name ?? ('n_a' | translate) }}
              </span>
            </div>
          </div>
        </div>
      }
      <!-- Additional information section -->
      @if (source_order_details.additional_information.length) {
        <div>
          <hr class="mx-n3" />
          <h4 class="mb-3">{{ 'additional_info' | translate }}</h4>
          <ng-container
            *ngTemplateOutlet="
              additionalInfo;
              context: { info: sortAdditionalInfo(source_order_details.additional_information) }
            "
          />
        </div>
      }
      <!-- Comments section -->
      @if (source_order_details && source_order_details.comments) {
        <div>
          <hr class="mx-n3" />
          <h4 class="mb-3">
            {{ 'comments' | translate }}
          </h4>
          <div class="row">
            <div class="col">
              <div class="d-flex flex-column">
                <span>{{ source_order_details.comments }}</span>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}

@if (is_review) {
  <div class="row g-3 flex-column">
    <!-- Activity asset card -->
    @if (asset_details.existing_asset) {
      <div class="col">
        <ts-selected-asset
          [order_type_id]="order_type_id"
          [asset_details]="asset_details"
          [additional_info]="additional_info"
          [shipping_address]="source_order_details.shipping_address"
          page_key="review"
        />
      </div>
    }
    <!-- Order Details card -->
    @if (show_order_details && ![13, 19].includes(order_type_id)) {
      <div class="col">
        <div class="card shadow-sm">
          <div class="card-body">
            <ng-template [ngTemplateOutlet]="orderDetailsHeader" />
            @if (price_summary && price_summary.is_bulk_order) {
              <ng-template [ngTemplateOutlet]="bulkOrderQuantityLabel" />
            }
            @if (price_summary && price_summary?.is_bulk_order) {
              <ts-bulk-order-details class="d-block mb-3" [price_summary]="price_summary" />
            }
            @if (price_summary && price_summary?.is_bulk_order) {
              <hr class="mx-n3" />
            }
            <ng-template [ngTemplateOutlet]="addressDetails" />
          </div>
        </div>
      </div>
    }

    @if (source_order_details?.new_carrier_account || source_order_details?.old_carrier_account) {
      <div class="col">
        <div class="card shadow-sm">
          <div class="card-body">
            <h4 class="mb-3">{{ 'carrier_account' | translate }}</h4>
            <div class="d-flex flex-column mb-3">
              <span class="fw-normal mb-2">{{ 'current_carrier_account' | translate }}</span>
              <span>
                {{ source_order_details?.old_carrier_account?.display_name ?? ('n_a' | translate) }}
              </span>
            </div>
            <div class="d-flex flex-column">
              <span class="fw-normal mb-2">{{ 'new_carrier_account' | translate }}</span>
              <span>
                {{ source_order_details?.new_carrier_account?.display_name ?? ('n_a' | translate) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Additional information card -->
    @if (source_order_details && source_order_details.additional_information.length) {
      <div class="col">
        <div class="card shadow-sm">
          <div class="card-body">
            <h4 class="pb-2">{{ 'additional_info' | translate }}</h4>
            <ng-container
              *ngTemplateOutlet="
                additionalInfo;
                context: { info: sortAdditionalInfo(source_order_details.additional_information) }
              "
            />
          </div>
        </div>
      </div>
    }
  </div>
}

<!-- Footer -->
<ng-content select="[navigate-dashboard]" />

<ng-template #orderDetailsHeader let-show_hr="show_hr">
  @if (show_hr) {
    <hr class="mx-n3" />
  }
  <div class="row d-flex justify-content-between card-title">
    <h4 class="col-6">{{ order_details_label | translate }}</h4>

    @if (source_order_details.carrier) {
      <div class="col-6 d-flex flex-column align-items-end">
        <img
          #carrier_img
          class="img-fluid carrier-img"
          src="{{ source_order_details.carrier.image_url }}"
          [alt]="source_order_details.carrier.name"
          [hidden]="carrier_img.hidden"
          (error)="carrier_img.hidden = true"
        />
        <h6 class="pt-2 text-secondary text-end">
          {{ source_order_details.carrier.name }}
        </h6>
      </div>
    }
  </div>
</ng-template>

<ng-template #bulkOrderQuantityLabel let-show_hr="show_hr">
  @if (show_hr) {
    <hr class="mx-n3" />
  }
  <div class="row">
    <div class="col">
      <h5 class="h5 mb-3">
        <span class="fw-light">{{ 'bulk_order_quantity' | translate }}:</span>
        {{ price_summary!.bulk_order_additional_info!.bulk_quantity! }}
      </h5>
    </div>
  </div>
</ng-template>

<ng-template #addressDetails>
  <div
    class="row row-cols-1 row-cols-sm-2 g-4"
    [ngClass]="{ 'row-cols-lg-3': !is_review, 'flex-column': is_review }"
  >
    @if (source_order_details.shipping_address) {
      <div class="col">
        <div class="d-flex flex-column">
          <span class="fw-normal mb-2">{{ shipping_address_label }}:</span>
          <span>{{ source_order_details.shipping_address.company_name }}</span>
          <span>{{ source_order_details.shipping_address.address1 }}</span>
          <span>{{ source_order_details.shipping_address.address2 }}</span>
          <span>
            {{ source_order_details.shipping_address.city }},
            {{ source_order_details.shipping_address.state }}
            {{ source_order_details.shipping_address.zip }}
          </span>
          <span>{{ source_order_details.shipping_address.country }}</span>
        </div>
      </div>
    }

    @if (source_order_details.preferred_address) {
      <div class="col">
        <div class="d-flex flex-column">
          <span class="fw-normal mb-2"> {{ 'preferred_area_location' | translate }}: </span>
          <span>{{ source_order_details.preferred_address.company_name }}</span>
          <span>{{ source_order_details.preferred_address.address1 }}</span>
          <span>{{ source_order_details.preferred_address.address2 }}</span>
          <span>
            {{ source_order_details.preferred_address.city }},
            {{ source_order_details.preferred_address.state }}
            {{ source_order_details.preferred_address.zip }}
          </span>
          <span>{{ source_order_details.preferred_address.country }}</span>
        </div>
      </div>
    }

    @if (source_order_details.shipping_method) {
      <div class="col">
        <div class="d-flex flex-column">
          <span class="fw-normal mb-2"> {{ 'shipping_method' | translate }}: </span>
          <span>{{ source_order_details.shipping_method }}</span>
        </div>
      </div>
    }
  </div>

  @if (source_order_details?.preferred_area_code) {
    <div class="col">
      <div class="d-flex flex-column">
        <span class="fw-normal mb-2"> {{ 'area_code' | translate }}: </span>
        <span>{{ source_order_details?.preferred_area_code }}</span>
      </div>
    </div>
  }

  @if (source_order_details?.preferred_calling_prefix) {
    <div class="col">
      <div class="d-flex flex-column">
        <span class="fw-normal mb-2"> {{ 'calling_prefix' | translate }}: </span>
        <span>{{ source_order_details?.preferred_calling_prefix }}</span>
      </div>
    </div>
  }
</ng-template>

<ng-template #nonBulkOrderSummary>
  @if (price_summary && (price_summary.one_time_costs || price_summary.recurring_costs)) {
    <hr class="mx-n3" />
  }
  <!-- One time cost table -->
  @if (price_summary && price_summary.one_time_costs) {
    <div class="table-responsive">
      <table class="table table-sm non-table">
        <thead>
          <th scope="col" class="h5 pb-2">
            {{ 'one_time_costs' | translate }}
            <span>({{ (isEmployeePayable() ? 'employee' : 'company') | translate }})</span>
          </th>
          <th scope="col"></th>
        </thead>
        <tbody class="table-group-divider border-light-subtle">
          @for (item of price_summary.one_time_costs; track item) {
            <tr>
              <td class="w-100">
                {{ item.name }} - {{ item.description }} (x {{ item.quantity | number: '1.0-0' }})
                &#64;
                {{ item.cost_to_currency }}

                @if (item?.additional_info?.option) {
                  <div>({{ 'option' | translate }}: {{ item?.additional_info?.option }})</div>
                }
              </td>
              <td class="text-end text-nowrap" [ngClass]="{ 'border-bottom-0': $last }">
                @if (item.employee_cost_to_currency && (item.type == 'ACCESSORY' || 'DEVICE')) {
                  <span
                    class="material-icons-outlined pe-2 card-icon cursor-default"
                    placement="top"
                    ngbTooltip="{{ 'employee_cost' | translate }}"
                  >
                    credit_card
                  </span>
                }
                {{ item.total_cost_to_currency }}
              </td>
            </tr>
          }
        </tbody>
        <tfoot class="table-group-divider border-light-subtle">
          <td class="h5 pt-3">{{ 'total' | translate }}</td>
          <td class="h5 pt-3 text-end text-nowrap">
            {{ price_summary.total_one_time_cost }}
          </td>
        </tfoot>
      </table>
    </div>
  }

  <!-- Recurring cost table -->
  @if (price_summary && price_summary.recurring_costs) {
    <div class="table-responsive mt-3">
      <table class="table table-sm mb-0 non-table">
        <thead>
          <th scope="col" class="h5 pb-2">
            {{ 'recurring_costs' | translate }}
            @if (order_type_id === 17) {
              <span> ({{ 'company' | translate }}) </span>
            }
          </th>
          <th scope="col"></th>
        </thead>
        <tbody class="table-group-divider border-light-subtle">
          @for (item of price_summary.recurring_costs; track item) {
            <tr>
              <td class="w-100">
                {{ item.name }}
                @if (item?.included) {
                  <span>({{ 'included' | translate }})</span>
                }
                @if (item?.additional_info?.unchanged) {
                  <span>({{ 'unchanged' | translate }})</span>
                }
              </td>
              <td class="text-end text-nowrap" [ngClass]="{ 'border-bottom-0': $last }">
                @if (getFeatureType(item)) {
                  <span class="pe-1">
                    <span
                      class="d-inline-flex"
                      [class.themed-badge-success]="item.sub_type === 'ADDED_FEATURE'"
                      [class.themed-badge-danger]="item.sub_type === 'REMOVED_FEATURE'"
                    >
                      ({{ getFeatureType(item) }})
                    </span>
                  </span>
                }
                <span [class.text-decoration-line-through]="item.sub_type === 'REMOVED_FEATURE'">
                  {{ item.total_cost_to_currency }}/mo.
                </span>
              </td>
            </tr>
          }
        </tbody>
        <tfoot class="table-group-divider border-light-subtle">
          <td class="h5 pt-3">{{ 'total' | translate }}</td>
          <td class="h5 pt-3 text-end text-nowrap">{{ price_summary.total_recurring_cost }}/mo.</td>
        </tfoot>
      </table>
    </div>
  }
</ng-template>

<ng-template #additionalInfo let-info="info">
  <div
    class="row row-cols-1"
    [ngClass]="[is_review ? 'flex-column g-3' : 'row-cols-sm-2 row-cols-lg-3 g-4']"
  >
    @for (field of info; track field) {
      @switch (field.type) {
        @case ('address') {
          @if (field.value) {
            <div class="col">
              <div class="d-flex flex-column">
                <span class="fw-normal mb-2" [innerHTML]="field.name | domSanitizer"> </span>
                <span>{{ field.value.address1 }}</span>
                <span>{{ field.value.address2 }}</span>
                <span>
                  {{ field.value.city }}
                  {{ field.value.state }}
                  {{ field.value.zip }}
                </span>
                <span>{{ field.value.country }}</span>
              </div>
            </div>
          }
        }
        @case ('file') {
          <div class="col">
            <div class="d-flex flex-column">
              <span class="fw-normal mb-2">{{ field.name }}</span>
              <a class="w-fit-content" href="javascript:void(0)" (click)="download(field.value)">
                {{ field.value.file_name }}
              </a>
            </div>
          </div>
        }
        @case ('person_select') {
          <div class="col">
            <div class="d-flex flex-column">
              <span class="fw-normal mb-2">{{ field.name }}</span>
              <span>{{ field.value.first_name }} {{ field.value.last_name }}</span>
              <span>({{ field.value.email }})</span>
            </div>
          </div>
        }
        @default {
          <div [ngClass]="field.type === 'textarea' ? 'col w-100' : 'col'">
            <div class="d-flex flex-column">
              <span class="fw-normal mb-2">{{ field.name }}</span>
              <span>{{ field.value }}</span>
            </div>
          </div>
        }
      }
    }
  </div>
</ng-template>
